import { Component } from '@angular/core';

@Component({
  selector: 'app-sidenav-layout',
  standalone: false,
  templateUrl: './sidenav-layout.html'
})
export class SidenavLayout {}
